import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignupComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private authServ: AuthService,
    private r: Router,
    private tstr: ToastrService,
    private router:ActivatedRoute
  ) {}
  referredBy=false
  ngOnInit(): void {
    this.router.queryParams.subscribe((r:{[key:string]:string})=>{
      if(r['referred_by']){
        this.referredBy = true
        this.signUpForm.controls.referred_by.setValue(r['referred_by'])
      }
    })
    }
  signUpForm = this.fb.group({
    // name: ['', Validators.required],
    // lname: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
    cpwd: ['', Validators.required],
    referred_by: [''],
    role: ['',Validators.required],
  });
  hide = true;
  hide1 = true;
  eye() {
    this.hide = !this.hide;
  }
  eye1() {
    this.hide1 = !this.hide1;
  }
  signUp() {
    if(this.signUpForm.controls.role.value == 'staff'){
      if(!(this.signUpForm.controls.email.value?.includes('heirslife') || this.signUpForm.controls.email.value?.includes('heirsgeneral') )){
      this.tstr.warning('email not recognised as staff mail');
        return;
      }
    }
      this.authServ.register(this.signUpForm.value).subscribe((r) => {
        this.login();
    })
    
  }
  login() {
    localStorage.clear()
    this.authServ.signIn({
      email: this.signUpForm.controls.email.value,
      password: this.signUpForm.controls.password.value,
    })
    .subscribe((r:any)=>{
      this.authServ.loader = false;
      sessionStorage.setItem('token',r.token)

      localStorage.setItem('user',JSON.stringify(r.user))
      localStorage.setItem('token',r.data.original.token)
      this.tstr.success('Successfully Registered');
      this.r.navigateByUrl('main/profile');
    })
  }
}
